import { render, staticRenderFns } from "./returnInvoice.vue?vue&type=template&id=70900502&"
import script from "./returnInvoice.vue?vue&type=script&lang=js&"
export * from "./returnInvoice.vue?vue&type=script&lang=js&"
import style0 from "./returnInvoice.vue?vue&type=style&index=0&id=70900502&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports